/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
/* eslint react/prop-types: 0 */
import React from 'react';
import ReactCommonmark from '@sonatype/react-commonmark';
import DetailLink from './DetailLink';
var RenderMarkdown = function RenderMarkdown(_a) {
    var children = _a.children;
    return React.createElement(ReactCommonmark, { source: children, softBreak: "br", escapeHtml: true, renderers: { link: DetailLink }, className: "nx-vulnerability-details__html-detail" });
};
export default RenderMarkdown;
//# sourceMappingURL=RenderMarkdown.js.map